import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Ecomm from "./components/Ecomm";
import { config } from './config';

const stripePromise = loadStripe(config.stripePublishableKey);

function App() {

  return (
    <Elements stripe={stripePromise}>
      <Ecomm />
    </Elements>
  );
}

export default App;
